/*
 *  Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import PenIcon from "@/src/assets/icons/traffic/toggleable/IconWriting";
import IncomingCallIcon from "@/src/assets/icons/traffic/toggleable/IconIncomingCall";
import HandshakeIcon from "@/src/assets/icons/traffic/toggleable/IconShakeHands";
import HowItWorksSectionBase from "@/src/components/Sections/Common/HowItWorksSection/HowItWorksSectionBase";

const HowItWorksSectionContract = () => {
  return (
    <HowItWorksSectionBase
      sections={[
        {
          title: "1. Fall schildern",
          description: "Sie schildern Ihren Fall und können Unterlagen zu Ihrem Vertrag hochladen.",
          icon: PenIcon,
        },
        {
          title: "2. Direkt Hilfe erhalten",
          description:
            "Wünschen Sie telefonische Beratung oder sollen auch rechtliche Schritte eingeleitet werden? Sie entscheiden und erhalten direkt professionelle Hilfe.",
          icon: IncomingCallIcon,
        },
        {
          title: "3. Weitere Schritte einleiten",
          description: "Wir prüfen Ihren Fall und setzen uns dafür ein, dass Sie zu Ihrem Recht gelangen!",
          icon: HandshakeIcon,
        },
      ]}
    />
  );
};

export default HowItWorksSectionContract;
